import { useOutletContext, useSearchParams } from "react-router-dom";
import {
  createAccounts,
  deleteAccounts,
  getAccounts,
  getCommoditiesTotalPurchasePrice,
  getCryptoTotalPurchasePrice,
  getFinancialsTotalPurchasePrice,
  getFirstPropertyPP,
  insertLogs,
} from "../../homepurchase.service";
import "primeicons/primeicons.css";
import { getSessionUserInformation, getProjectedAssetValue } from "app/utils/utility.service";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";

import { Accordion, AccordionTab } from "primereact/accordion";
import { NumericFormat } from "react-number-format";
import AddAssets from "./AddAssets";
import EditAccounts from "./EditAccounts";
import { formatNumber } from "app/utils/utility.service";
import { InputText } from "primereact/inputtext";
import { Loading } from "app/components";
import { getSessionClientInformation } from "app/utils/utility.service";
import { CATEGORIES_LIABILITIES } from "app/utils/Constants";
import { CATEGORIES_ASSETS } from "app/utils/Constants";

const Accounts = () => {
  const { data, setData } = useOutletContext(); // Access Parent's state

  //const sessionValues = getSessionUserInformation();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
   const clientId = searchParams.get("clientid");
   let sessionValues =
      clientId && clientId !== "null"
        ? getSessionClientInformation()
        : getSessionUserInformation();
   const clientInfo = getSessionClientInformation();
  if (clientInfo) {
    sessionValues = clientInfo;
  }
  const userId =
      clientId && clientId !== "null" ? clientId : sessionValues?.id;
  const [activeIndex, setActiveIndex] = useState([]);
  const [activeIndexLiabilities, setActiveIndexLiabilities] = useState([]);
  const [title, setTitle] = useState("");
  const [stock, setStock] = useState("");
  const [firstPropertyPrice, setFirstPropertyPrice] = useState("");
  const [selCategory, setSelCategory] = useState();

  const [assetsModal, setAssetsModal] = useState(false);
  const [editAssetsModal, setEditAssetsModal] = useState(false);
  const [editLiabilitiesModal, setEditLiabilitiesModal] = useState(false);
  const toast = useRef();
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const [categories, setCategories] = useState(CATEGORIES_ASSETS);
  const [categoriesLiabilities, setCategoriesLiabilities] = useState(CATEGORIES_LIABILITIES);
  const handleAddAssetsModal = (type) => {
    if (!assetsModal) {
      const payload = {
        description: "AssetModal",
      };
      insertLogs(payload);
    }
    setTitle(type);
    setAssetsModal(!assetsModal);
  };
  const renderAddAssetsModal = () => (
    <AddAssets
      assetsModal={assetsModal}
      handleAddAssetsModal={handleAddAssetsModal}
      categories={categories}
      fetchAccounts={fetchAccounts}
      title={title}
    />
  );

  const handleEditAssetsModal = (category, type) => {
    setSelCategory(category);
    setTitle(type);
    handleCancel(type);
    if (type === "Assets") setEditAssetsModal(!editAssetsModal);
    else setEditLiabilitiesModal(!editLiabilitiesModal);
  };

   const handleDeleteAssets = async (category, type) => {
    let res = await deleteAccounts(category.account_id);
    if (res?.success) {
      showSuccess("Category deleted successfully.");
      // Update local state to remove the deleted category without refetching
      if (type === "Assets") {
        setCategories(prev => prev.filter(cat => cat.account_id !== category.account_id));
      } else if (type === "Liabilities") {
        setCategoriesLiabilities(prev => prev.filter(cat => cat.account_id !== category.account_id));
      }
    } else {
      showError("Error while deleting category");
    }
  };
  const renderEditAssetsModal = () => (
    <EditAccounts
      editAssetsModal={editAssetsModal}
      handleEditAssetsModal={handleEditAssetsModal}
      categories={categories}
      setCategories={setCategories}
      selCategory={selCategory}
      setSelCategory={setSelCategory}
      title={title}
      fetchAccounts={fetchAccounts}
      
    />
  );
  const renderEditLiabilitiesModal = () => (
    <EditAccounts
      editAssetsModal={editLiabilitiesModal}
      handleEditAssetsModal={handleEditAssetsModal}
      categories={categoriesLiabilities}
      setCategories={setCategoriesLiabilities}
      selCategory={selCategory}
      setSelCategory={setSelCategory}
      title={title}
      fetchAccounts={fetchAccounts}
    />
  );
  useEffect(() => {
    setData({ dataPresent: false });
    fetchAccounts();
    
  }, []);
 

  const fetchAccounts = async () => {

    let stockVal = await getTotalPurchasePrice(userId);
    let comVal = await getTotalPurchasePriceComm(userId);
    let cryptoVal = await getTotalPurchasePriceCrypto(userId);

    let firstProperty = await getFirstPropertyPurchasePrice(userId);
    
    let apiData = await getAccounts(userId);
    const groupedByType = apiData.reduce((acc, item) => {
      const type = item.type || "Unknown"; // Fallback for empty types
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(item);
      return acc;
    }, {});
    // Create a map of static categories for quick lookup
    const staticMap = new Map(
      categories.map((cat) => [cat.account_name, { ...cat }])
    );
    staticMap.get("Brokerage Accounts")?.subcategories?.forEach((sub) => {
      if (sub.name === "Stocks") sub.value = stockVal;
    });
    staticMap.get("Cryptocurrency")?.subcategories?.forEach((sub) => {
      if (sub.name === "Cryptocurrency") sub.value = cryptoVal;
    });
    staticMap.get("Commodities")?.subcategories?.forEach((sub) => {
      if (sub.name === "Commodities") sub.value = comVal;
    });
    
    staticMap.get("Property")?.subcategories?.forEach((sub) => {
      if (sub.name === "Primary residence") sub.value = firstProperty?.purchasePrice;
    });
    
    // Iterate over API categories
    groupedByType["Assets"]?.forEach((apiCat) => {
      const existingCat = staticMap.get(apiCat.account_name);

      if (existingCat) {
        existingCat.account_id = apiCat.id;
        // Map existing subcategories by name for quick access
        const subMap = new Map(
          existingCat.subcategories.map((sub) => [sub.name, { ...sub }])
        );

        // Update or add subcategories
        apiCat.accountCategories.forEach((apiSub) => {
          const sub = subMap.get(apiSub.name);
          let val = getProjectedAssetValue(apiSub.value,apiSub.annualGrowth,apiSub.reinvest, apiSub.purchaseDate);
          if(apiSub.name == categories[1].subcategories[0].name) val = stockVal;
          if(apiSub.name == categories[5].subcategories[0].name) val = comVal;
          if(apiSub.name == categories[6].subcategories[0].name) val = cryptoVal;
          if (sub) {
            sub.value = Number(apiSub.value);
            sub.projectedValue = val;
            sub.id = apiSub.id;
            sub. annualGrowth = apiSub.annualGrowth;
            sub.annualIncome= apiSub.annualIncome;
            sub.purchaseDate=apiSub.purchaseDate;
            sub.reinvest=apiSub.reinvest;
            sub.isRealEstateProperty=apiSub.isRealEstateProperty;
            //sub.isStatic = true;
          } else {
            subMap.set(apiSub.name, {
              id: apiSub.id, // Use actual ID if available
              name: apiSub.name,
              value: Number(apiSub.value),
              projectedValue:val,
              isStatic: false,
               annualGrowth:apiSub.annualGrowth,
            annualIncome:apiSub.annualIncome,
            purchaseDate:apiSub.purchaseDate,
            reinvest:apiSub.reinvest,
            isRealEstateProperty:apiSub.isRealEstateProperty
            });
          }
        });

        // Update subcategories in the map
        existingCat.subcategories = Array.from(subMap.values());
        staticMap.set(apiCat.account_name, existingCat);
      } else {
        
        // New category from API
        staticMap.set(apiCat.account_name, {
          categoryId: apiCat.id,
          account_name: apiCat.account_name,
          account_id: apiCat.id,
          subcategories: apiCat.accountCategories.map((sub) => {
            let val = getProjectedAssetValue(sub.value,sub.annualGrowth,sub.reinvest,sub.purchaseDate);
            return {
            id: sub.id,
            name: sub.name,
            value: Number(sub.value),
            projectedValue: val,
            isStatic: false,
            annualGrowth:sub.annualGrowth,
            annualIncome:sub.annualIncome,
            purchaseDate:sub.purchaseDate,
            reinvest:sub.reinvest,
            isRealEstateProperty:sub.isRealEstateProperty
          }}
        ),
        });
      }
    });

    // Set merged result
    setCategories(Array.from(staticMap.values()));

    const staticMapLiabilities = new Map(
      categoriesLiabilities.map((cat) => [cat.account_name, { ...cat }])
    );
    staticMapLiabilities.get("Loans & Mortgages")?.subcategories?.forEach((sub) => {
      if (sub.name === "Primary residence") sub.value = firstProperty?.mortgageTotal;
    });
    groupedByType["Liabilities"]?.forEach((apiCat) => {
      const existingCat = staticMapLiabilities.get(apiCat.account_name);

      if (existingCat) {
        existingCat.account_id = apiCat.id;
        // Map existing subcategories by name for quick access
        const subMap = new Map(
          existingCat.subcategories.map((sub) => [sub.name, { ...sub }])
        );

        // Update or add subcategories
        apiCat.accountCategories.forEach((apiSub) => {
          const sub = subMap.get(apiSub.name);
          if (sub) {
            sub.value = Number(apiSub.value);
            sub.id = apiSub.id;
            //sub.isStatic = true;
          } else {
            subMap.set(apiSub.name, {
              id: apiSub.id, // Use actual ID if available
              name: apiSub.name,
              value: Number(apiSub.value),
              isRealEstateProperty: apiSub.isRealEstateProperty,
              isStatic: false,
            });
          }
        });

        // Update subcategories in the map
        existingCat.subcategories = Array.from(subMap.values());
        staticMapLiabilities.set(apiCat.account_name, existingCat);
      } else {
        // New category from API
        staticMapLiabilities.set(apiCat.account_name, {
          categoryId: apiCat.id,
          account_name: apiCat.account_name,
          account_id: apiCat.id,
          subcategories: apiCat.accountCategories.map((sub) => ({
            id: sub.id,
            name: sub.name,
            value: Number(sub.value),
            isStatic: false,
          })),
        });
      }
    });
    setCategoriesLiabilities(Array.from(staticMapLiabilities.values()));
  };

  const getTotalPurchasePrice = async () => {

      let fetchedRecord = await getFinancialsTotalPurchasePrice(userId);
      if (fetchedRecord) {
        setIsLoading(false);
        setStock(fetchedRecord.total);
        return fetchedRecord.total;
      } else {
        setIsLoading(false);
      }
    };
    const getTotalPurchasePriceComm = async () => {

      let fetchedRecord = await getCommoditiesTotalPurchasePrice(userId);
      if (fetchedRecord) {
        setIsLoading(false);
        setStock(fetchedRecord.total);
        return fetchedRecord.total;
      } else {
        setIsLoading(false);
      }
    };
    const getTotalPurchasePriceCrypto = async () => {

      let fetchedRecord = await getCryptoTotalPurchasePrice(userId);
      if (fetchedRecord) {
        setIsLoading(false);
        setStock(fetchedRecord.total);
        return fetchedRecord.total;
      } else {
        setIsLoading(false);
      }
    };
    const getFirstPropertyPurchasePrice = async () => {

      let fetchedRecord = await getFirstPropertyPP(userId);
      if (fetchedRecord) {
        setIsLoading(false);
        setFirstPropertyPrice(fetchedRecord.purchasePrice);
        return fetchedRecord.record;
      } else {
        setIsLoading(false);
      }
    };


  // Update Value of a Subcategory
  const handleValueChange = (categoryIndex, subIndex, value, type) => {
    let updatedCategories;
    if (type === "Assets") updatedCategories = [...categories];
    else updatedCategories = [...categoriesLiabilities];

    updatedCategories[categoryIndex].subcategories[subIndex].value =
      Number(value);

    if (type === "Assets") setCategories(updatedCategories);
    else setCategoriesLiabilities(updatedCategories);
  };
  const handleCancel = (type) => {
    if (type === "Assets") setActiveIndex([]);
    else setActiveIndexLiabilities([]); // collapse all tabs
  };
  // Save Data (Only Save Non-Empty Values)
  const handleSave = async (type) => {
    let filteredCategories;
    if (type === "Assets")
      filteredCategories = categories
        .map((category) => ({
          ...category,
          subcategories: category.subcategories.filter(
            (sub) => sub.value && Number(sub.value) !== 0
          ),
        }))
        .filter((category) => category.subcategories.length > 0);
    // Remove empty categories
    else
      filteredCategories = categoriesLiabilities
        .map((category) => ({
          ...category,
          subcategories: category.subcategories.filter(
            (sub) => sub.value != null
          ),
        }))
        .filter((category) => category.subcategories.length > 0); // Remove empty categories

    if (filteredCategories.length === 0) {
      alert("No valid data to save.");
      return;
    }
    
    const payload = {
      userId: userId, 
      categories: filteredCategories,
      type: type,
    };
    setIsLoading(true);
    let rec = await createAccounts(payload);
    if (rec) {
      showSuccess("Account saved successfully");
      setIsLoading(false);
      fetchAccounts();
      handleCancel(type);
    } else {
      showError(rec.message);
    }
  };
  const handleTabChange = (e) => {
    const newIndex = e.index;

    // Handle multiple active indexes (if multiple={true})
    const filteredIndex = Array.isArray(newIndex)
      ? newIndex.filter((i) => categories[i]?.subcategories?.length > 0)
      : categories[newIndex]?.subcategories?.length > 0
      ? newIndex
      : activeIndex; // keep old state if not allowed

    setActiveIndex(filteredIndex);
  };
  const handleTabChangeLiabilities = (e) => {
    const newIndex = e.index;

    // Handle multiple active indexes (if multiple={true})
    const filteredIndex = Array.isArray(newIndex)
      ? newIndex.filter(
          (i) => categoriesLiabilities[i]?.subcategories?.length > 0
        )
      : categoriesLiabilities[newIndex]?.subcategories?.length > 0
      ? newIndex
      : activeIndex; // keep old state if not allowed

    setActiveIndexLiabilities(filteredIndex);
  };
  const toggleAccordion = (index, type) => {
    if (type === "Assets") {
      const newActiveIndex = activeIndex.includes(index)
        ? activeIndex.filter((i) => i !== index)
        : [...activeIndex, index];
      setActiveIndex(newActiveIndex);
    } else if (type === "Liabilities") {
      const newActiveIndex = activeIndexLiabilities.includes(index)
        ? activeIndexLiabilities.filter((i) => i !== index)
        : [...activeIndexLiabilities, index];
      setActiveIndexLiabilities(newActiveIndex);
    }
  };
  // Function to render custom header with edit icon
  const renderHeader = (category, index) => {
    const hasSubcategories = category.subcategories?.length > 0;
    const isExpanded = activeIndex.includes(index); // only works with multiple={true}
    return (
      <div className="flex align-items-center justify-content-between mt-4">
        <div className="col-6">
          <span style={{ color: "#6c757d" }} className="ml-2 ">
            {category.account_name}
          </span>
        </div>
        <div className="flex align-items-center gap-2">
        
          <Button
            icon="pi pi-pencil"
            className="p-button-text"
            onClick={(e) => {
              e.stopPropagation(); // prevents accordion toggle
              e.preventDefault();
              handleEditAssetsModal(category, "Assets");
            }}
          />
         
          {hasSubcategories && (
              <Button
              icon={`pi ${isExpanded ? "pi-minus" : "pi-plus"}`}
              className="p-button-text"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleAccordion(index, "Assets");
              }}
            />
          
          )}
          {!category.isStatic && (
            <Button
            icon="pi pi-trash"
            className="p-button-text"
            onClick={(e) => {
              handleDeleteAssets(category, "Assets");
            }}
          />
          )}
        </div>
      </div>
    );
  };
  const renderHeaderLiabilities = (category, index) => {
    const hasSubcategories = category.subcategories?.length > 0;
    const isExpanded = activeIndexLiabilities.includes(index); 
    return (
      <div className="flex align-items-center justify-content-between mt-4">
        <span style={{ color: "#6c757d" }} className="ml-3">
          {category.account_name}
        </span>
        <div className="flex align-items-center gap-2">
          <Button
            icon="pi pi-pencil"
            className="p-button-text"
            onClick={(e) => {
              e.stopPropagation(); // prevents accordion toggle
              e.preventDefault();
              handleEditAssetsModal(category, "Liabilities");
            }}
          />

          {hasSubcategories && (
            <Button
              icon={`pi ${isExpanded ? "pi-minus" : "pi-plus"}`}
              className="p-button-text"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleAccordion(index, "Liabilities");
              }}
            />
          )}
           {!category.isStatic && (
            <Button
            icon="pi pi-trash"
            className="p-button-text"
            onClick={(e) => {
              handleDeleteAssets(category, "Liabilities");
            }}
          />
          )}
        </div>
      </div>
    );
  };
  const grandTotalAssets = categories.reduce((acc, category) => {
    const total = category.subcategories?.reduce(
      (sum, sub) => sum + Number(sub.projectedValue || 0),
      0
    );
    return acc + total;
  }, 0);
  const grandTotalLiabilities = categoriesLiabilities.reduce(
    (acc, category) => {
      const total = category.subcategories?.reduce(
        (sum, sub) => sum + Number(sub.value || 0),
        0
      );
      return acc + total;
    },
    0
  );
  return (
    <div className="Accounts" style={{ paddingTop: "5px" }}>
      <Toast ref={toast} className="ToastMessage" />
      {isLoading && <Loading />}
      <div className="grid">
        <div className="col-5" style={{ width: "45%", paddingLeft: "3rem" }}>
          <div>
            <div className="section-container">
              <div className="section-header ">
                <span class="title">Assets</span>

                <Button 
                  label="Add"
                  onClick={() => handleAddAssetsModal("Assets")}
                  className="col-12 p-button-link text-black underline align-text-rt"
                  style={{ color: "black",boxShadow: 'none'  }}
                />
              </div>
            </div>
            <div style={{ textAlign: "end" }}></div>
            <Accordion
              style={{ height: "412px", overflow: "auto" }}
              multiple
              activeIndex={activeIndex}
              onTabChange={handleTabChange}
            >
              {categories?.map((category, index) => {
                const total = category.subcategories?.reduce(
                  (sum, sub) => sum + Number(sub.projectedValue || 0),
                  0
                );
                return (
                  <AccordionTab
                    key={category?.categoryId}
                    header={renderHeader(category, index)}
                  >
                    {category.subcategories?.map((sub, subIndex) => (
                      <div key={sub.id} className="flex align-items-center">
                        <div className="col-4">
                          <label>{sub.name}</label>
                        </div>
                        <div className="col-6 ml-3">
                          {/* Disable fields where the values come from other tabs   */}
                          <NumericFormat
                            className="input-field  "
                            style={{ width: "20rem", color:"#495057" }}
                            value={sub.projectedValue}
                            disabled={true}
                            thousandSeparator=","
                            onValueChange={(e) =>
                              handleValueChange(
                                index,
                                subIndex,
                                e.value,
                                "Assets"
                              )
                            }
                            mode="currency"
                            decimalScale={0}
                            currency="USD"
                            prefix="$ "
                          />
                        </div>
                      </div>
                    ))}

                    <div
                      className="flex"
                      style={{
                        alignItems: "center",
                      }}
                    >
                      <div className="col-4">
                        <label>Total {category.account_name}</label>
                      </div>
                      <div className="col-4 ml-3">
                        <InputText
                          className="input-field"
                          value={"$ " + formatNumber(total)}
                          thousandSeparator=","
                          style={{ width: "20rem" }}
                          disabled={true}
                          mode="currency"
                          currency="USD"
                        
                        />
                      </div>
                    </div>
                  </AccordionTab>
                );
              })}
            </Accordion>

            <div
              className="flex"
              style={{
                alignItems: "center",
                color: "#6c757d",
                fontWeight: "600",
                fontSize: "1.4rem",
              }}
            >
              <div className="col-4 ml-3">Total Assets</div>
              <div className="col-4">
                <InputText
                  className="input-field"
                  value={"$ " + formatNumber(grandTotalAssets)}
                  thousandSeparator=","
                  style={{ width: "20rem" }}
                  disabled={true}
                  mode="currency"
                  currency="USD"
                  
                />
              </div>
            </div>
          </div>
          <div>
            <Button
              label="Cancel"
              className="ml-4 mt-4 p-button-raised  p-button-lg"
              onClick={() => handleCancel("Assets")}
            />
            <Button
              label="Save"
              className="ml-4 p-button-raised p-button-lg p-button-warning"
              onClick={() => handleSave("Assets")}
            />
          </div>
        </div>
        <div className="vertical-line-cls"></div>
        <div className="col-5" style={{ width: "48.5%" }}>
          <div>
            <div className="section-container">
              <div className="section-header ">
                <span class="title">Liabilities</span>
                
                <Button 
                  label="Add"
                  onClick={() => handleAddAssetsModal("Liabilities")}
                  className="col-12 p-button-link text-black underline align-text-rt"
                  style={{ color: "black",boxShadow: 'none'  }}
                />
              </div>
            </div>

            <Accordion
              activeIndex={activeIndexLiabilities}
              onTabChange={handleTabChangeLiabilities}
              multiple
              style={{ height: "412px", overflow: "auto" }}
            >
              {categoriesLiabilities.map((category, categoryIndex) => {
                const total = category.subcategories?.reduce(
                  (sum, sub) => sum + Number(sub.value || 0),
                  0
                );

                return (
                  <AccordionTab
                    key={category.categoryId}
                    header={renderHeaderLiabilities(category, categoryIndex)}
                  >
                    <div className="">
                      {category.subcategories.map((sub, subIndex) => (
                        <div key={sub.id} className="flex align-items-center ">
                          <div className="col-4">
                            <label>{sub.name}</label>
                          </div>
                          <div className="col-6 ml-3">
                            <NumericFormat
                              className="input-field"
                              value={sub.value}
                              thousandSeparator=","
                              style={{ width: "20rem" }}
                              onValueChange={(e) =>
                                handleValueChange(
                                  categoryIndex,
                                  subIndex,
                                  e.value,
                                  "Liabilities"
                                )
                              }
                              decimalScale={0}
                              mode="currency"
                              currency="USD"
                              prefix="$ "
                            />
                          </div>
                        </div>
                      ))}
                      <div
                        className="flex"
                        style={{
                          alignItems: "center",
                        }}
                      >
                        <div className="col-4">
                          <label>Total {category.account_name}</label>
                        </div>
                        <div className="col-4 ml-3">
                          <InputText
                            className="input-field"
                            value={"$ " + formatNumber(total)}
                            thousandSeparator=","
                            style={{ width: "20rem" }}
                            disabled={true}
                            mode="currency"
                            currency="USD"
                           
                          />
                        </div>
                      </div>
                    </div>
                  </AccordionTab>
                );
              })}
            </Accordion>
            <div
              className="flex "
              style={{
                alignItems: "center",
                color: "#6c757d",
                fontWeight: "600",
                fontSize: "1.4rem",
              }}
            >
              <div className="col-4 ml-3">Total Liabilities</div>
              <div className="col-4">
                <InputText
                  className="input-field"
                  value={"$ " + formatNumber(grandTotalLiabilities)}
                  thousandSeparator=","
                  style={{ width: "20rem" }}
                  disabled={true}
                  mode="currency"
                  currency="USD"
                  
                />
              </div>
              
            </div>
            <div
              className="flex "
              style={{
                alignItems: "center",
                color: "#6c757d",
                fontWeight: "600",
                fontSize: "1.4rem",
              }}
            >
              
        <div className="col-4 ml-3">Current Net Worth</div>
              <div className="col-4">
                <InputText
                  className="input-field"
                  value={"$ " + formatNumber(grandTotalAssets-grandTotalLiabilities)}
                  thousandSeparator=","
                  style={{ width: "20rem" }}
                  disabled={true}
                  mode="currency"
                  currency="USD"
                  
                />
              </div>
              </div>
          </div>
          <div>
            <Button
              label="Cancel"
              className="ml-4 mt-4 p-button-raised p-button-lg"
              onClick={() => handleCancel("Liabilities")}
            />
            <Button
              label="Save"
              className="ml-4 p-button-raised p-button-lg p-button-warning"
              onClick={() => handleSave("Liabilities")}
            />
          </div>
        </div>
        
      </div>
      {assetsModal && renderAddAssetsModal()}
      {editAssetsModal && renderEditAssetsModal()}
      {editLiabilitiesModal && renderEditLiabilitiesModal()}
    </div>
  );
};
export default Accounts;
